import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Prompt } from "react-router";
import { Link, Switch, Route } from "react-router-dom";
import { FormGroup, ControlLabel, Row } from "react-bootstrap";
// import {setFilter} from '../actions/filters'
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import { fetchEndpointIfNeeded as ftch } from "../actions/fetch";
import BreadCrumb from "./breadCrumb";
import EndpointForm from "./endpointForm";
import IntegrationForm from "./integrationForm";
import IntegrationMappingForm from "./integrationMappingForm";
import { CSSTransition } from "react-transition-group";
import {
  editEndpointList,
  executeEndpointList,
  archiveEndpointList
} from "../actions/endpoints";
import EndpointPagination from "./endpointPagination";
import { PAGE_BUTTON_ID, REST_API } from "../actions/constants";
import { setCurrentListPage } from "../actions/pages";
import NumericFilter from "./filters/numericFilter";
import DateTimeFilter from "./filters/dateTimeFilter";
import TextFilter from "./filters/textFilter";
import passThruFilter from "./utilities/passThruFilter";
import BooleanFilter from "./filters/booleanFilter";
import ReferenceFilter from "./filters/referenceFilter";
import StatusFilter from "./filters/statusFilter";
import TextStatusFilter from "./filters/textStatusFilter";
import QueueFilter from "./filters/queueFilter";
// import DateTimeFilter from "./filters/dateTimeFilter";
import ShowItems from "./filters/showItems";
import { showMessage, closeMessage } from "../actions/messageBox";
import JsonViewerModal from "./utilities/JsonViewerModal";
import CodeEditorModal from "./utilities/CodeEditorModal";
import _ from "lodash";
import moment from "moment";
import sidebars from "../config";
import getParams from "./utilities/getParams";
import {
  setLoader,
  setLoaderMessagequeue,
  setLoaderExport
} from "../actions/loader";
import { showModal } from "../actions/customModal";
import { exportXML, exportXMLwithOptions } from "../actions/export";
import { isObject } from "formik";

import { setFilter } from "../actions/filters";
import { setDate } from '../actions/dateFilter';
import DatePick from '../components/datepick';
import DateRangePicker from '../components/filters/DateRangePicker'

class EndpointList extends Component {
  constructor(props) {
    super(props);
    this.sb = this.props.sidebar;
    this.state = {
      toggledListId: 0,
      spinTaskProcessing: 0,
      isHidden: true,
      hideStyle: {
        whiteSpace: "nowrap",
        width: "50px",
        overflow: "hidden",
        textOverflow: "ellipsis"
      },
      isDisable: true,
      isButtonClicked: false,
      isTestButtonClicked: false,
      currentClickedButtonId: null,
      loader: false,
      archiveStatus: false,
      isDate: '',
      dateFilterValue1 : "",
      dateFilterValue2 : "",
      onClear: false
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.handleRefreshList = this.handleRefreshList.bind(this);
    this.handleClearFilters = this.handleClearFilters.bind(this);
    this.handleArchiveList = this.handleArchiveList.bind(this);
    this.handleHideStyle = this.handleHideStyle.bind(this);
    this.handleExecute = this.handleExecute.bind(this);
    this.refreshOnFilterChange = this.refreshOnFilterChange.bind(this);
    this.refreshOnFilterChange = _.debounce(this.refreshOnFilterChange, 1000);
  }
  AbortController = new window.AbortController();

  handleExecute(value) {
    this.setState({
      enableExecute: value
    });
  }
   handleDateChange = (event) => {

    this.setState({
      isDate: event
    });
   }

  onChangeDateFilter = (date, fil) => {

    try {

      var val1 = moment(date[0]).format('YYYY-MM-DD')
      var val2 = moment(date[1]).format('YYYY-MM-DD')
      console.log('DATES UPDATE fil',fil)
      // date = date.target.value
        if(val1 != 'Invalid date' ){
          console.log('DATES UPDATE comp',[val1,val2])

          if(val2 != 'Invalid date' ){
            this.setState({
              dateFilterValue1:val1,
              dateFilterValue2:val2
            },() => {
              this.bindToStateDateFilter(this.state.dateFilterValue1,this.state.dateFilterValue2)
            });
          }
        }else{
          console.log('DATES UPDATE HERE ELSE',[val1,val2])
          this.handleClearFilters(fil);
        }
    } catch(e) {

      console.log('onChangeDateFilter Error: ', e)
    }
  }
  
  bindToStateDateFilter = (val,val1) => {
    //EXCLUSIVE FOR MESSAGEQUEUE DATE FILTER
    let filter = {}
        filter['updated_at'] = {
            type: "dateTime",
            value1: [val,val1]
        }
        //this.props.dispatch(setFilter(14,filter));
        this.props.dispatch(setDate([val,val1]));
        
        this.handleRefreshList();
  }

  onChangeDate = (event) => {
    console.log('EVEN',event)
  }

  handleToggle(e, endpoint, list) {
    let currentStatus = e.target.checked;

    if (!currentStatus) {
      this.props.dispatch(
        showMessage({
          type: "info",
          title: "Confirm",
          message: (
            <span>
              Set <b>{list.name ? list.name + " " : ""}</b>to <b>Inactive</b>?
            </span>
          ),
          buttonArray: ["Yes", "No"],
          autoClose: false,
          onClick: buttonIndex => {
            if (buttonIndex === 0) {
              this.props.dispatch(
                editEndpointList(
                  endpoint.id,
                  endpoint.name,
                  this.props.auth.access_token,
                  Object.assign(
                    {},
                    {
                      id: list.id,
                      status: currentStatus ? 1 : 0
                    }
                  ),
                  "PATCH"
                )
              );

              if (endpoint.name === "tasks" && !currentStatus) {
                let schedEndpoint = this.props.endpoints.find(
                  endP => endP.name === "schedules"
                );
                let associatedSchedule = schedEndpoint.list.find(
                  sched => sched.task_id === list.id
                );
                if (associatedSchedule && associatedSchedule.status === 1) {
                  this.props.dispatch(
                    editEndpointList(
                      schedEndpoint.id,
                      "schedules",
                      this.props.auth.access_token,
                      {
                        id: associatedSchedule.id,
                        status: 0
                      },
                      "PATCH"
                    )
                  );
                }
              }

              // Change the state.
              this.setState(
                {
                  toggledListId: list.id
                },
                () => {
                  this.props.dispatch(closeMessage());
                  this.handleRefreshList();
                }
              );
            } else {
              this.props.dispatch(closeMessage());
            }
          }
        })
      );
    } else if (currentStatus && endpoint.name != "schedules") {
      this.props.dispatch(
        showMessage({
          type: "info",
          title: "Confirm",
          message: (
            <span>
              Set <b>{list.name ? list.name + " " : ""}</b>to <b>Active</b>?
            </span>
          ),
          buttonArray: ["Yes", "No"],
          autoClose: false,
          onClick: buttonIndex => {
            if (buttonIndex === 0) {
              this.props.dispatch(
                editEndpointList(
                  endpoint.id,
                  endpoint.name,
                  this.props.auth.access_token,
                  Object.assign(
                    {},
                    {
                      id: list.id,
                      status: !currentStatus ? 0 : 1
                    }
                  ),
                  "PATCH"
                )
              );
              // Change the state.
              this.setState(
                {
                  toggledListId: list.id
                },
                () => {
                  this.props.dispatch(closeMessage());
                  this.handleRefreshList();
                }
              );
            } else {
              this.props.dispatch(closeMessage());
            }
          }
        })
      );
    } else {
      if (endpoint.name === "schedules" && currentStatus) {
        let taskEndpoint = this.props.endpoints.find(
          endP => endP.name === "tasks"
        );
        let associatedTask = taskEndpoint.list.find(
          task => task.id === list.task_id
        );
        if (associatedTask && associatedTask.status === 0) {
          let sbLabel = sidebars.find(sidebar => sidebar.endpointId === 1)
            .label;
          sbLabel = sbLabel.toLowerCase();
          let integrationLink = `${sbLabel}/${associatedTask.id}`;
          this.props.dispatch(
            showMessage({
              type: "error",
              title: "Action not allowed",
              message: (
                <p>
                  You cannot activate a schedule for an inactive integration.
                  Please activate the integration first <br />
                  <a
                    href={integrationLink}
                    onClick={e => {
                      e.preventDefault();
                      this.props.dispatch(closeMessage());
                      this.props.history.push(integrationLink);
                      return false;
                    }}
                  >
                    Go to integration page
                  </a>
                </p>
              )
            })
          );
          return false;
        } else {
          this.props.dispatch(
            showMessage({
              type: "info",
              title: "Confirm",
              message: (
                <span>
                  Set <b>{list.name ? list.name + " " : ""}</b>to <b>Active</b>?
                </span>
              ),
              buttonArray: ["Yes", "No"],
              autoClose: false,
              onClick: buttonIndex => {
                if (buttonIndex === 0) {
                  this.props.dispatch(
                    editEndpointList(
                      endpoint.id,
                      endpoint.name,
                      this.props.auth.access_token,
                      Object.assign(
                        {},
                        {
                          id: list.id,
                          status: !currentStatus ? 0 : 1
                        }
                      ),
                      "PATCH"
                    )
                  );
                  // Change the state.
                  this.setState(
                    {
                      toggledListId: list.id
                    },
                    () => {
                      this.props.dispatch(closeMessage());
                      this.handleRefreshList();
                    }
                  );
                } else {
                  this.props.dispatch(closeMessage());
                }
              }
            })
          );
        }
      }

      // this.props.dispatch(editEndpointList(
      //     endpoint.id,
      //     endpoint.name,
      //     this.props.auth.access_token,
      //     Object.assign({}, {
      //         id: list.id,
      //         status: currentStatus ? 1 : 0
      //     }),
      //     "PATCH"
      // ))

      if (endpoint.name === "tasks" && !currentStatus) {
        let schedEndpoint = this.props.endpoints.find(
          endP => endP.name === "schedules"
        );
        let associatedSchedule = schedEndpoint.list.find(
          sched => sched.task_id === list.id
        );
        if (associatedSchedule && associatedSchedule.status === 1) {
          this.props.dispatch(
            editEndpointList(
              schedEndpoint.id,
              "schedules",
              this.props.auth.access_token,
              {
                id: associatedSchedule.id,
                status: 0
              },
              "PATCH"
            )
          );
        }
      }

      // Change the state.
      this.setState({
        toggledListId: list.id
      });
    }
    this.handleRefreshList();
  }

  handleArchiveList(filter) {
    let getFilter = filter;
    // console.log("getFilter",getFilter)
  }

  handleHideStyle(e) {
    let getAllDiv = document.getElementsByName(e.target.getAttribute("name"));

    if (this.state.isHidden) {
      if (getAllDiv.length != 0) {
        for (let a in getAllDiv) {
          if (getAllDiv[a].style != undefined) {
            if (getAllDiv[a].style.whiteSpace != undefined) {
              getAllDiv[a].style.whiteSpace = "";
            }
            if (getAllDiv[a].style.width != undefined) {
              getAllDiv[a].style.width = "";
            }
            if (getAllDiv[a].style.overflow != undefined) {
              getAllDiv[a].style.overflow = "";
            }
            if (getAllDiv[a].style.textOverflow != undefined) {
              getAllDiv[a].style.textOverflow = "";
            }
          }
        }
      }
      e.target.style.whiteSpace = "";
      e.target.style.width = "";
      e.target.style.overflow = "";
      e.target.style.textOverflow = "";

      this.setState(state => ({
        isHidden: false
      }));
    } else {
      if (getAllDiv) {
        for (let a in getAllDiv) {
          if (getAllDiv[a].style != undefined) {
            if (getAllDiv[a].style.whiteSpace != undefined) {
              getAllDiv[a].style.whiteSpace = "nowrap";
            }
            if (getAllDiv[a].style.width != undefined) {
              getAllDiv[a].style.width = "50px";
            }
            if (getAllDiv[a].style.overflow != undefined) {
              getAllDiv[a].style.overflow = "hidden";
            }
            if (getAllDiv[a].style.textOverflow != undefined) {
              getAllDiv[a].style.textOverflow = "ellipsis";
            }
          }
        }
      }
      e.target.style.whiteSpace = "nowrap";
      e.target.style.width = "50px";
      e.target.style.overflow = "hidden";
      e.target.style.textOverflow = "ellipsis";

      this.setState(state => ({
        isHidden: true
      }));
    }
  }

  handleDeleteJobQueue = async () => {
    await fetch(
      `
                    ${REST_API}/jobqueues/deleteAll?
						&
						access_token=${this.props.auth.access_token}
					`,
      {
        method: "DELETE",
        signal: this.AbortController.signal
      }
    )
      .then(res => {
        return res.json();
      })
      .then(data => {
        this.handleRefreshList();
        this.props.dispatch(setLoaderMessagequeue(false))
        setTimeout(() => {
          this.setState({
            spinTaskProcessing: 0
          });
        }, 300);

        return {
          data: data
        };
      })
      .catch(err => {
        this.props.dispatch(setLoaderMessagequeue(false))
      })
  };

  handleTriggerDelete = () => {
    this.props.dispatch(
      showMessage({
        type: "info",
        title: "Confirm",
        message: (
          <span>
            Job-queues to be deleted are queues before the <b>last 7 days</b>.
            Click <b>Yes</b> to continue.{" "}
          </span>
        ),
        buttonArray: ["Yes", "No"],
        autoClose: false,
        onClick: buttonIndex => {
          if (buttonIndex === 0) {
            this.props.dispatch(setLoaderMessagequeue(true))
            this.handleDeleteJobQueue();
            this.handleRefreshList();
          } else {
            this.props.dispatch(closeMessage());
          }
        }
      })
    );
  };

  componentDidUpdate() {
    //this.props.dispatch(ftch(15));
    
    //this.props.dispatch(ftch(14));

  }

  componentDidMount() {
    let sb = this.sb;

    if (sb && sb.endpointId) {
      this.props.dispatch(ftch(sb.endpointId));
      //this.props.dispatch(ftch(15));
    }

    this.props.dispatch(ftch(10));
    this.props.dispatch(ftch(11))

    // if (sb.endpointId === 14 || sb.endpointId === 3) {
    //     setTimeout(() => {
    //         this.handleRefreshList()

    //     }, 100)
    // }

    if (sb.endpointId) {
      setTimeout(() => {
        this.handleRefreshList();
      }, 100);
    }
  }

  componentWillUnmount() {
    this.AbortController.abort();
  }

  breadCrumb = () => {
    let breadCrumbs = window.location.href.split("/" || "-");
    // let breadCrumb = null
    // breadCrumbs.map(breadCrumb => {
    //     var crumb = breadCrumb.split('-').slice(1)
    //     console.log(crumb[0].charAt(0).toUpperCase())
    // })
    // console.log(breadCrumbs[3].split('-').map(e => e.charAt(0).toUpperCase() + e.slice(1)))
    // console.log(breadCrumbs[3])

    return breadCrumbs;
  };

  handleRefreshList() {
    let sb = this.sb;

    if (sb && sb.endpointId) {
      this.props.dispatch(ftch(sb.endpointId, true));
      //this.props.dispatch(ftch(15, true));
    }
    // alert('touched')
  }

  refreshOnFilterChange() {
    this.handleRefreshList();
  }

  handleClearFilters(filters) {
    this.handleRefreshList();
    filters.forEach(filter => {
      if (
        this.refs[filter.ref] &&
        this.refs[filter.ref].wrappedInstance &&
        this.refs[filter.ref].wrappedInstance.clearFilter &&
        typeof this.refs[filter.ref].wrappedInstance.clearFilter === "function"
      ) {
        this.refs[filter.ref].wrappedInstance.clearFilter();
      }
    });
    this.setState({
      dateFilterValue1: '',
      dateFilterValue1: '',
      onClear: true
    })
    setTimeout(() => {
      this.handleRefreshList();
      
    }, 100);

    setTimeout(()=>{
      this.setState({
        onClear: false
      })
    }, 3000)

    //CLEAR FILTER STORE
    this.props.dispatch(setDate(''));



    let sb = this.sb;
    // if (sb && sb.endpointId == 3) {
    //     console.log("going to dispatch")
    //     this.props.dispatch(
    //         ftch(sb.endpointId, true)
    //     )
    // }
    
  }

  render() {
    const params = getParams(this.props.location.search);

    // Get variables from props thru destructuring.
    let {
      match,
      endpoints,
      location,
      main,
      handleClick,
      handleClickPagination,
      auth,
      loader,
      dispatch,
      exportLoader
    } = this.props;

    // console.log("this.props",this.props)

    let isUserAdmin = auth.user ? auth.user.isAdmin : false;
    let isUserSuper =
      auth.user.email === "super@excelym.com" ? auth.user.email : "";
    let enableExecute = this.state.enableExecute;

    // if(isMobile){
    //     alert("Moible")
    // }else if(isBrowser){
    //     alert("Browser")
    // }

    // console.log("endpoints", endpoints)

    // Shortcut for React JS
    const e = React.createElement;

    // Get the sidebar.
    let sb = this.sb;

    // Check for errors.
    let err = main.error ? "Error" : null;

    // Define operations.
    // const ops = isUserAdmin && !sb.config.readOnly ? [
    //     'edit',
    //     'new'
    // ] : ['edit']

    // Define forms.
    const displayForm = {
      EndpointForm,
      IntegrationForm,
      IntegrationMappingForm
    };

    let extraRoutes = [];

    // Endpoints without description.
    // const descArr = [
    //     'Users',
    //     'Roles',
    //     'ACLs',
    //     'Data-Source-Mapping',
    //     'Data-Source-Mapping-Fields',
    //     'Queues'
    // ]

    // const active = <span className="active-status">Active</span>
    // const inActive = <span className="inactive-status">Inactive</span>

    // Create description column.
    // let descriptionColumn = descArr.indexOf( sb.label ) !== -1 ?
    //     '' : <span>Description</span>

    // Generate endpoint.
    let endpoint = endpoints.find(e => e.id === sb.endpointId);
    // Deconstruct endpoint object to individual variables.
    let {
      itemsPerPage,
      listPages,
      currentListPage,
      list,
      listOrder,
      listCount,
      filter,
      isFetching,
      apiPaged,
      name: endpointName // use endpointName for destructured variable
    } = endpoint;
    // Filter the list
    let currentList = passThruFilter(list, filter);
    
    let buttonList = [];
    let checkFilterStatus = false;

    let getAuditList;
    let getUserList;
    let getConnectionList;
    let getProviderList;
    let getDatasourceList;
    let getDatasourcemappingList;
    let getScheduleList;
    let getFrequencyList;
    let hasActiveSchedule;
    let taskScheduleStatus;

    for (let n in endpoints) {
      if (endpoints[n].name === "audits") {
        getAuditList = endpoints[n].list;
      } else if (endpoints[n].name === "users") {
        getUserList = endpoints[n].list;
      } else if (endpoints[n].name === "providers") {
        getProviderList = endpoints[n].list;
      } else if (endpoints[n].name === "connections") {
        getConnectionList = endpoints[n].list;
      } else if (endpoints[n].name === "datasources") {
        getDatasourceList = endpoints[n].list;
      } else if (endpoints[n].name === "datasourcemappings") {
        getDatasourcemappingList = endpoints[n].list;
      } else if (endpoints[n].name === "frequencies") {
        getFrequencyList = endpoints[n].list;
      } else if (endpoints[n].name === "schedules") {
        getScheduleList = endpoints[n].list;
      }
    }

    let listHeaders = [];

    let newCurrentList = [];

    // if(currentList){
    //     if(currentList[0]){
    //         let keys = Object.keys(currentList[0])
    //         console.log("keys",keys)
    //         for(let b in keys){
    //             let keyLabel = keys[b].replace(/_/g, " ");
    //             let capitalizedKeyLabel = keyLabel.charAt(0).toUpperCase() + keyLabel.slice(1)
    //             listHeaders.push({label:capitalizedKeyLabel,key:keys[b]})
    //         }

    //     }

    // }

    // if(currentList){
    //     let getTaskEndpoint = this.props.endpoints.find(endP => endP.name === 'tasks')
    //     for(let a in currentList){
    //         let newDestructuredList = (({task_id,ref_id,target_id,status,updated_at}) => ({task_id,ref_id,target_id,status,updated_at}))(currentList[a]);
    //         newCurrentList.push(newDestructuredList)
    //     }

    //     if(newCurrentList){
    //         for(let d in newCurrentList){
    //             if(newCurrentList[d].task_id){
    //                 let getTaskName = getTaskEndpoint.list.find(x => x.id === newCurrentList[d].task_id)
    //                 if(getTaskName){
    //                     newCurrentList[d].task_id = getTaskName.name
    //                 }
    //             }

    //             if(newCurrentList[d].status){
    //              let newStatus = sb.config.displayProperties[2].enumMap.get(newCurrentList[d].status)

    //              if(newStatus){
    //                 newCurrentList[d].status = `${newStatus} (${newCurrentList[d].status})`

    //              }
    //             }

    //             if(newCurrentList[d].updated_at){
    //                 let newUpdated = moment(newCurrentList[d].updated_at).format('MM-DD-YYYY HH:mm:ss')

    //                 if(newUpdated){
    //                     newCurrentList[d].updated_at = newUpdated
    //                 }
    //             }
    //         }
    //     }

    //     if(currentList[0]){

    //         let keys = Object.keys(currentList[0])
    //         let newDestructuredKeys = []
    //         for(let b in keys){
    //             if(keys[b]=="task_id"||keys[b]=="ref_id"||keys[b]=="target_id"||keys[b]=="status"||keys[b]=="updated_at"){
    //                 newDestructuredKeys.push(keys[b])

    //             }
    //         }
    //         if(newDestructuredKeys){
    //             for(let c in newDestructuredKeys){
    //                 let keyLabel = newDestructuredKeys[c].replace(/_/g, " ");
    //                 let capitalizedKeyLabel = keyLabel.charAt(0).toUpperCase() + keyLabel.slice(1)
    //                 listHeaders.push({label:capitalizedKeyLabel,key:newDestructuredKeys[c]})
    //             }
    //         }
    //     }
    // }

    if (endpoint.name === "messagequeues") {
      if (
        (filter && filter.status && filter.status.value1 == "100" && isUserAdmin) ||
        (filter && filter.status && filter.status.value1 == "-1")
      ) {
        checkFilterStatus = true;
      }
    }

    if (listOrder === "descending") {
      currentList.reverse();
    }

    // Compute page start and end
    let listStart = itemsPerPage * currentListPage;

    if (listStart < 0) {
      listStart = 0;
    }

    let listEnd = listStart + itemsPerPage;

    let displayList = apiPaged
      ? currentList
      : currentList.slice(listStart, listEnd);

    // buttonList.push(
    //     <button
    //         type="button"
    //         key={`${endpointName}-advance-btn-clear`}
    //         className="btn float-left"
    //         data-toggle="tooltip"
    //         data-placement="top"
    //         title="advance filter"
    //         onClick={e => { this.props.dispatch(showModal({
    //             type: "info",
    //             title: "Info",
    //             message: <span>Archive Successful</span>
    //         })) }}>
    //         {/* Clear filter */}
    //         <i class="fas fa-filter"></i>
    //     </button>
    // )

    //Generate the buttons
    buttonList.push(
      <button
        type="button"
        key={`${endpointName}-clear-btn-clear`}
        className="btn float-left"
        data-toggle="tooltip"
        data-placement="top"
        title="clear filter"
        onClick={e => {
          this.handleClearFilters(filters);
        }}
      >
        {/* Clear filter */}
        <i className="fas fa-eraser"></i>
      </button>
    );

    buttonList.push(
      <button
        type="button"
        key={`${endpointName}-btn-refresh`}
        className="btn float-right"
        data-toggle="tooltip"
        data-placement="top"
        title="refresh list"
        onClick={this.handleRefreshList}
        disabled={isFetching}
      >
        <i className={"fas fa-sync-alt" + (isFetching ? " fa-spin" : "")}></i>
      </button>
    );

    if (endpointName == "messagequeues") {
      {
        isBrowser &&
         /* isUserAdmin &&*/
          buttonList.push(
            <button
              type="button"
              key={`${endpointName}-btn-archive`}
              className="btn float-none"
              disabled={checkFilterStatus /*&& isUserAdmin == true*/ ? false : true}
              data-toggle="tooltip"
              data-placement="top"
              title="archive"
              onClick={() => {
                this.props.dispatch(
                  showMessage({
                    type: "info",
                    title: "Confirm",
                    message: <span>Select Starting Date</span>,
                    buttonArray: ["Yes", "No"],
                    autoClose: false,
                    isDate: true,
                    onClick: buttonIndex => {
                      if (buttonIndex === 0) {
                        this.props.dispatch(setLoaderMessagequeue(true));
                        let getDateVal = this.props.messageBox.dateVal;
                        let getStatusFilter = filter.status.value1;

                        let data = {
                          selected_date: getDateVal,
                          status_filter: getStatusFilter
                        };

                        if (getDateVal && getStatusFilter) {
                          this.props
                            .dispatch(
                              archiveEndpointList(
                                "messagequeues",
                                this.props.auth.access_token,
                                data,
                                "POST"
                              )
                            )
                            .then(response => {
                              console.log("RESPONSE", response);
                              if (response.success) {
                                this.props.dispatch(
                                  setLoaderMessagequeue(false)
                                );
                                this.props.dispatch(
                                  showMessage({
                                    type: "success",
                                    title: "Success",
                                    message: <span>Archive Successful</span>
                                  })
                                );
                                this.handleRefreshList();
                              } else {
                                this.props.dispatch(
                                  setLoaderMessagequeue(false)
                                );
                                this.props.dispatch(
                                  showMessage({
                                    type: "error",
                                    title: "Failed",
                                    message: (
                                      <span>
                                        Unable to archive. Please Contact
                                        Administrator
                                      </span>
                                    )
                                  })
                                );
                                this.handleRefreshList();
                              }
                            });

                          // this.handleRefreshList()
                        }
                      }
                    }
                  })
                );
              }}
            >
              <i className="fas fa-archive"></i>&nbsp;
              {/* Archive */}
            </button>
          );
      }

      {
        isBrowser &&
          buttonList.push(
            <button
              type="button"
              key={`${endpointName}-btn-export`}
              className="btn float-none"
              data-toggle="tooltip"
              data-placement="top"
              title="export"
              onClick={() => {
                this.props.dispatch(
                  showMessage({
                    type: "info",
                    title: "Confirmation",
                    message: (
                      <span>
                        Are you sure you want to export message-queues?
                      </span>
                    ),
                    buttonArray: ["Yes", "No"],
                    autoClose: false,
                    isFailedExport:
                      filter.status.value1 === "-1" ? true : false,
                    onClick: buttonIndex => {
                      if (buttonIndex === 0) {
                        this.props.dispatch(setLoaderExport(true));

                        let refId;
                        let targetId;
                        let statusId;
                        let taskId;
                        let failedExtract;
                        let failedPublish;

                        if (filter.status.value1 === "-1") {
                          failedExtract =
                            this.props.messageBox &&
                            this.props.messageBox.failedExtract;
                          failedPublish =
                            this.props.messageBox &&
                            this.props.messageBox.failedPublish;
                        }

                        // console.log("failedExtract",failedExtract)
                        // console.log("failedPublish",failedPublish)

                        if (filter) {
                          if (
                            filter &&
                            filter.ref_id &&
                            filter.ref_id.value1 != ".*"
                          ) {
                            refId = filter.ref_id.value1;
                          }

                          if (
                            filter &&
                            filter.status &&
                            filter.status.value1 != "0"
                          ) {
                            statusId = filter.status.value1;
                          }

                          if (
                            filter &&
                            filter.target_id &&
                            filter.target_id.value1 != ".*"
                          ) {
                            targetId = filter.target_id.value1;
                          }

                          if (
                            filter &&
                            filter.task_id &&
                            filter.task_id.value1 != ""
                          ) {
                            taskId = filter.task_id.value1;
                          }
                          var maxLimit = localStorage.getItem(
                            "export_max_limit"
                          );

                          let filterObject = {
                            refId: refId,
                            taskId: taskId,
                            statusId: statusId,
                            targetId: targetId,
                            limit: maxLimit,
                            date1: this.state.dateFilterValue1 ? this.state.dateFilterValue1 : null,
                            date2: this.state.dateFilterValue2 ? this.state.dateFilterValue2 : null,
                            userId: this.props.userId
                          };

                          if (filter.status.value1 === "-1") {
                            dispatch(
                              exportXMLwithOptions(
                                filterObject,
                                this.props.auth.access_token,
                                failedExtract,
                                failedPublish
                              )
                            )
                              .then(response => {
                                let getUrl = response;
                                if (!getUrl.error) {
                                  window.open(getUrl, "_blank");
                                } else {
                                  this.props.dispatch(
                                    showMessage({
                                      type: "error",
                                      title: "Failed",
                                      isFailedExport: false,
                                      message: (
                                        <span>
                                          Unable to Export. Please Contact
                                          Administrator.
                                        </span>
                                      )
                                    })
                                  );
                                }
                                this.props.dispatch(setLoaderExport(false));
                              })

                              .catch(error => {});
                          } else {
                            dispatch(
                              exportXML(
                                filterObject,
                                this.props.auth.access_token
                              )
                            )
                              .then(response => {
                                // console.log('this.props',this.props)
                                let getUrl = response;
                                if (!getUrl.error) {
                                  window.open(getUrl, "_blank");
                                } else {
                                  this.props.dispatch(
                                    showMessage({
                                      type: "error",
                                      title: "Failed",
                                      isFailedExport: false,
                                      message: (
                                        <span>
                                          Unable to Export. Please Contact
                                          Administrator.
                                        </span>
                                      )
                                    })
                                  );
                                }
                                this.props.dispatch(setLoaderExport(false));
                              })
                              .catch(error => {});
                          }
                        }
                      } else {
                        let failedExtract =
                          this.props.messageBox &&
                          this.props.messageBox.failedExtract;
                        let failedPublish =
                          this.props.messageBox &&
                          this.props.messageBox.failedPublish;

            
                        this.props.dispatch(closeMessage());
                      }
                    }
                  })
                );
              }}
              disabled={
                isUserAdmin == true
                  ? false
                  : isUserSuper === "super@excelym.com"
                  ? false
                  : filter.status.value1 === "-1"
                  ? false
                  : true
              }
            >
              <i className="fas fa-file-csv"></i>&nbsp;
            </button>
          );
      }

      // }
    } else if (endpointName == "jobqueues") {
      {
        isBrowser &&
          isUserAdmin &&
          buttonList.push(
            <button
              type="button"
              key={`${endpointName}-btn-delete`}
              className="btn float-none"
              data-toggle="tooltip"
              data-placement="top"
              title="delete"
              onClick={this.handleTriggerDelete}
              disabled={isUserAdmin == true ? false : true}
            >
              <i className="fas fa-trash"></i>&nbsp;
              {/* Delete */}
            </button>
          );
      }
    }

    //End of Generate Button

    // Generate the list.
    // THIS IS THE ENDPOINT TABLE LIST
    let lst = displayList.length
      ? displayList.map((l, listIndex) => {
          let preList = [];
          let innerList = [];
          let activated = "";
          // let spinner = ''
          if (l["status"]) {
            activated = "checked";
          } else {
            activated = "";
          }

          // if( l.id === this.state.toggledListId &&
          //     isFetching )
          //     spinner = <div style={{textAlign: 'center'}} className="">
          //         <i className="fa fa-circle-notch fa-spin fa-md"></i>
          //     </div>
          // else spinner = l['status'] ? active : inActive

          sb.config.preDisplayProperties.forEach(dp => {
            let fieldName = typeof dp === "string" ? dp : dp.field;
            let displayText = "";

            if (dp.type === "string") {
              displayText = l[fieldName];
            }

            if (
              dp.type === "reference" &&
              dp.referenceEndpoint &&
              dp.referenceField
            ) {
              let referenceId = Number(l[fieldName]) || "";
              let referenceEndpoint = endpoints.find(
                endP => endP.name === dp.referenceEndpoint
              );
              let referenceObject = referenceEndpoint
                ? referenceEndpoint.list.find(ref => ref.id === referenceId)
                : null;
              let referenceText = referenceObject
                ? referenceObject[dp.referenceField]
                : "";
              displayText = referenceText || referenceId;
            } else if (dp.type === "enum" && dp.enumMap) {
              let actualValue = l[fieldName];
              displayText =
                `${dp.enumMap.get(actualValue)} (${actualValue})` ||
                actualValue;
            } else if (dp.type === "datetime" && dp.dateFormat) {
              let actualValue = l[fieldName];

              displayText = moment(
                actualValue,
                "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]"
              ).isValid()
                ? moment(
                    actualValue,
                    "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]"
                  ).format(dp.dateFormat)
                : " ";
            } else if (dp.type === "componentLink" && dp.componentLinkPath) {
              displayText = (
                <Link
                  to={`${sb.label.toLowerCase()}/${l.id}/${
                    dp.componentLinkPath
                  }`}
                  className="btn btn-sm btn-group justify-content-center align-items-center"
                >
                  {dp.componentLinkText}
                  {dp.componentLinkIcon ? (
                    <i className={`fas ${dp.componentLinkIcon}`}></i>
                  ) : (
                    ""
                  )}
                </Link>
              );

              extraRoutes.push({
                path: `/${sb.label.toLowerCase()}/:id/${dp.componentLinkPath}`,
                componentName: dp.componentName
              });
            }
            preList.push(
              <div
                className={`${dp.columnClass || "col"} ${dp.pxClass || "px-1"}`}
                key={`${endpointName}-${listIndex}-${fieldName}-value`}
              >
                {displayText}
              </div>
            );
          });

          sb.config.displayProperties.forEach((dp, id) => {
            if (isBrowser) {
              let fieldName = typeof dp === "string" ? dp : dp.field;

              let displayText = "";

              if (dp.type === "string" && dp.field == "offset_value") {
                displayText = (l[fieldName] > 0 ? "+" : "") + parseFloat(l[fieldName]).toFixed(2)
              } else if (dp.type === "string" && dp.field == "dst") {
                displayText = l[fieldName] ? "T" : "F";
              } else if (dp.type === "string" && dp.field == "is_processed") {
                displayText = l[fieldName] === "T" ? "YES" : "NO";
              } else if (dp.type === "string" && dp.field == "duration") {
                let getStartDate = moment(
                  l["process_start_at"],
                  "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]"
                ).isValid()
                  ? moment(
                      l["process_start_at"],
                      "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]"
                    ).format(dp.dateFormat)
                  : " ";
                let getEndDate = moment(
                  l["process_end_at"],
                  "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]"
                ).isValid()
                  ? moment(
                      l["process_end_at"],
                      "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]"
                    ).format(dp.dateFormat)
                  : " ";

                if (getStartDate && getEndDate) {
                  let getTimeDiff = moment
                    .duration(
                      moment(getEndDate, " HH:mm:ss").diff(
                        moment(getStartDate, " HH:mm:ss")
                      )
                    )
                    .as("seconds");
                  let duration = moment
                    .utc(getTimeDiff * 1000)
                    .format("HH:mm:ss");
                  if (duration == "Invalid date") {
                    duration = "00:00:00";
                  }

                  displayText = <span>{duration}</span>;
                }
              } else if (dp.type === "string" && dp.field == "frequency") {
                let freq_id = l.frequency_id;
                let freq = getFrequencyList.find(gfl => gfl.id === freq_id);

                let freqName = freq && freq.name;
                if (freqName) {
                  displayText = freqName;
                } else {
                  displayText = "---";
                }
              } else if (dp.field === "remarks" && dp.type === "json") {
                // kyll
                //CHECK FOR REMARKS FIELD
                var remarks = l.remarks ? JSON.parse(l.remarks) : null;
              // displayText =
              //   remarks && remarks["message"] != " "
              //     ? typeof remarks["message"] == 'object' ? remarks["Code"] ? remarks["Code"] : JSON.stringify(remarks["message"]) : remarks["message"]
              //     : "";

              displayText = "";

              if (remarks) {
                  if(remarks.message && typeof remarks.message == 'object'){
                      displayText = remarks.message.Message ? remarks.message.Message : remarks.message.Code ? remarks.message.Code : JSON.stringify(remarks.message)
                  }else if(remarks.message){
                      displayText = remarks.message
                  }else {
                      displayText = remarks.message != null ? remarks.message : ''
                  }
              }
                
              } else if (dp.type == "string") {
                displayText = l[fieldName];
              }
              // if (dp.type === "string") {
              //     displayText = l[fieldName]
              //     console.log("hi")
              // } else if (dp.type === "string" && dp.field == "is_processed") {
              //     console.log("HELLLO")
              // }

              // if (dp.type === "string" && dp.field === "memo") {
              //     console.log("l", l)
              //     displayText = (
              //         <Link to={`${sb.label.toLowerCase()}/${l.id}`}>
              //             {l.memo}
              //         </Link>
              //     )
              // }
              if (
                dp.type === "reference" &&
                dp.referenceEndpoint &&
                dp.referenceField
              ) {
                let referenceId = Number(l[fieldName]) || "";
                let referenceEndpoint = endpoints.find(
                  endP => endP.name === dp.referenceEndpoint
                );
                let referenceObject = referenceEndpoint
                  ? referenceEndpoint.list.find(ref => ref.id === referenceId)
                  : null;
                let referenceText = referenceObject
                  ? referenceObject[dp.referenceField]
                  : "";
                displayText = referenceText || referenceId;
              } else if (dp.type === "enum" && dp.enumMap) {
                let actualValue = l[fieldName];
                displayText =
                  `${dp.enumMap.get(actualValue)} (${actualValue})` ||
                  actualValue;
              } else if (dp.type === "datetime" && dp.dateFormat) {
                let actualValue = l[fieldName];
                displayText = moment(
                  actualValue,
                  "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]"
                ).isValid()
                  ? moment(
                      actualValue,
                      "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]"
                    ).format(dp.dateFormat)
                  : " ";
              } else if (dp.type === "componentLink" && dp.componentLinkPath) {
                displayText = (
                  <Link
                    to={`${sb.label.toLowerCase()}/${l.id}/${
                      dp.componentLinkPath
                    }`}
                    className="btn btn-sm btn-group justify-content-center align-items-center"
                  >
                    {dp.componentLinkText}
                    {dp.componentLinkIcon ? (
                      <i className={`fas ${dp.componentLinkIcon}`}></i>
                    ) : (
                      ""
                    )}
                  </Link>
                );

                extraRoutes.push({
                  path: `/${sb.label.toLowerCase()}/:id/${
                    dp.componentLinkPath
                  }`,
                  componentName: dp.componentName
                });
              }

              if (dp.field == "memo") {
                innerList.push(
                  <div
                    className={`${dp.columnClass || "col"} ${dp.paddingClass ||
                      "px-5"}`}
                    key={`${endpointName}-${listIndex}-${fieldName}-value`}
                  >
                    <div className="btn-group btn-group-xs" role="group">
                      {displayText ? (
                        <JsonViewerModal
                          id={`[${l.id}].memo`}
                          name={`[${l.id}].memo`}
                          modalTitle="Memo"
                          index={listIndex}
                          value={displayText || ""}
                          enforceArgs={["val"]}
                          buttonText={"View"}
                          buttonTitle="memo"
                        />
                      ) : null}
                      {/* <Link to={`${sb.label.toLowerCase()}/${l.id}`}>
                                    {displayText}
                                </Link> */}
                    </div>
                  </div>
                );
              } else {
                innerList.push(
                  <div
                    style={this.state.hideStyle}
                    name={`list-${endpointName}-${listIndex}`}
                    className={`${dp.columnClass || "col"} ${dp.pxClass ||
                      "px-1"}`}
                    key={`${endpointName}-${listIndex}-${fieldName}-value`}
                    onClick={e => {
                      this.handleHideStyle(e);
                    }}
                  >
                    {displayText}
                  </div>
                );
              }
            } else if (isMobile) {
              if (dp.mobile == true) {
                let fieldName = typeof dp === "string" ? dp : dp.field;

                let displayText = "";
                if (
                  dp.type === "string" &&
                  dp.field == "is_processed" &&
                  dp.mobile == true
                ) {
                  displayText = l[fieldName] === "T" ? "YES" : "NO";
                } else if (
                  dp.type === "string" &&
                  (dp.field == "duration") & (dp.mobile == true)
                ) {
                  let getStartDate = moment(
                    l["process_start_at"],
                    "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]"
                  ).isValid()
                    ? moment(
                        l["process_start_at"],
                        "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]"
                      ).format(dp.dateFormat)
                    : " ";
                  let getEndDate = moment(
                    l["process_end_at"],
                    "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]"
                  ).isValid()
                    ? moment(
                        l["process_end_at"],
                        "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]"
                      ).format(dp.dateFormat)
                    : " ";

                  if (getStartDate && getEndDate) {
                    let getTimeDiff = moment
                      .duration(
                        moment(getEndDate, " HH:mm:ss").diff(
                          moment(getStartDate, " HH:mm:ss")
                        )
                      )
                      .as("seconds");
                    let duration = moment
                      .utc(getTimeDiff * 1000)
                      .format("HH:mm:ss");
                    if (duration == "Invalid date") {
                      duration = "00:00:00";
                    }

                    displayText = <span>{duration}</span>;
                  }
                } else if (
                  dp.type === "string" &&
                  dp.field == "frequency" &&
                  dp.mobile == true
                ) {
                  let freq_id = l.frequency_id;
                  let freq = getFrequencyList.find(gfl => gfl.id === freq_id);

                  let freqName = freq && freq.name;
                  if (freqName) {
                    displayText = freqName;
                  } else {
                    displayText = "---";
                  }
                } else if (dp.type == "string" && dp.mobile == true) {
                  displayText = l[fieldName];
                }

                if (
                  dp.type === "reference" &&
                  dp.referenceEndpoint &&
                  dp.referenceField &&
                  dp.mobile == true
                ) {
                  let referenceId = Number(l[fieldName]) || "";
                  let referenceEndpoint = endpoints.find(
                    endP => endP.name === dp.referenceEndpoint
                  );
                  let referenceObject = referenceEndpoint
                    ? referenceEndpoint.list.find(ref => ref.id === referenceId)
                    : null;
                  let referenceText = referenceObject
                    ? referenceObject[dp.referenceField]
                    : "";
                  displayText = referenceText || referenceId;
                } else if (
                  dp.type === "enum" &&
                  dp.enumMap &&
                  dp.mobile == true
                ) {
                  let actualValue = l[fieldName];
                  displayText =
                    `${dp.enumMap.get(actualValue)} (${actualValue})` ||
                    actualValue;
                } else if (
                  dp.type === "datetime" &&
                  dp.dateFormat &&
                  dp.mobile == true
                ) {
                  let actualValue = l[fieldName];
                  displayText = moment(
                    actualValue,
                    "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]"
                  ).isValid()
                    ? moment(
                        actualValue,
                        "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]"
                      ).format(dp.dateFormat)
                    : " ";
                } else if (
                  dp.type === "componentLink" &&
                  dp.componentLinkPath &&
                  dp.mobile == true
                ) {
                  displayText = (
                    <Link
                      to={`${sb.label.toLowerCase()}/${l.id}/${
                        dp.componentLinkPath
                      }`}
                      className="btn btn-sm btn-group justify-content-center align-items-center"
                    >
                      {dp.componentLinkText}
                      {dp.componentLinkIcon ? (
                        <i className={`fas ${dp.componentLinkIcon}`}></i>
                      ) : (
                        ""
                      )}
                    </Link>
                  );

                  extraRoutes.push({
                    path: `/${sb.label.toLowerCase()}/:id/${
                      dp.componentLinkPath
                    }`,
                    componentName: dp.componentName
                  });
                }
                if (dp.field == "memo") {
                  innerList.push(
                    <div
                      className={`${dp.columnClass ||
                        "col"} ${dp.paddingClass || "px-5"}`}
                      key={`${endpointName}-${listIndex}-${fieldName}-value`}
                    >
                      <div className="btn-group btn-group-xs" role="group">
                        {displayText ? (
                          <JsonViewerModal
                            id={`[${l.id}].memo`}
                            name={`[${l.id}].memo`}
                            modalTitle="Memo"
                            index={listIndex}
                            value={displayText || ""}
                            enforceArgs={["val"]}
                            buttonText={"View"}
                            buttonTitle="memo"
                          />
                        ) : null}
                        {/* <Link to={`${sb.label.toLowerCase()}/${l.id}`}>
                                        {displayText}
                                    </Link> */}
                      </div>
                    </div>
                  );
                } else {
                  innerList.push(
                    <div
                      style={this.state.hideStyle}
                      name={`list-${endpointName}-${listIndex}`}
                      className={`${dp.columnClass || "col"} ${dp.pxClass ||
                        "px-1"}`}
                      key={`${endpointName}-${listIndex}-${fieldName}-value`}
                      onClick={e => {
                        this.handleHideStyle(e);
                      }}
                    >
                      {displayText}
                    </div>
                  );
                }
              }
            }

            // let hideStyle = {
            //     "white-space": "nowrap",
            //     "width": "50px",
            //     "overflow": "hidden",
            //     "text-overflow": "ellipsis"
            // }

            // if (dp.field == "memo") {
            //     innerList.push(
            //         <div className={`${dp.columnClass || "col"} ${dp.paddingClass || "px-5"}`} key={`${endpointName}-${listIndex}-${fieldName}-value`} >
            //             <div className="btn-group btn-group-xs" role="group">
            //                 {displayText ?
            //                     <JsonViewerModal
            //                         id={`[${l.id}].memo`}
            //                         name={`[${l.id}].memo`}
            //                         modalTitle="Memo"
            //                         index={listIndex}
            //                         value={displayText || ""}
            //                         enforceArgs={["val"]}
            //                         buttonText={"View"}
            //                         buttonTitle="memo"
            //                     /> : null}
            //                 {/* <Link to={`${sb.label.toLowerCase()}/${l.id}`}>
            //                 {displayText}
            //             </Link> */}
            //             </div >
            //         </div >
            //     )
            // } else {
            //     innerList.push(
            //         <div style={this.state.hideStyle} name={`list-${endpointName}-${listIndex}`} className={`${dp.columnClass || "col"} ${dp.pxClass || "px-1"}`} key={`${endpointName}-${listIndex}-${fieldName}-value`} onClick={(e)=>{this.handleHideStyle(e)}}>
            //             {displayText}
            //         </div >
            //     )
            // }

            // innerList.push(
            //     <div className={`${dp.columnClass || "col"} px-1`} key={`${endpointName}-${listIndex}-${fieldName}-value`}>
            //         {displayText}
            //     </div>
            // )
          });

          if (
            endpointName !== "providers" &&
            endpointName !== "messagequeues" &&
            endpointName !== "jobqueues" &&
            l.hasOwnProperty("status")
          ) {
            /* Hide this column for now
                <div className="col-1 float-left text-center"> 
                    { spinner }
                </div>
                    */
            // let getAuditList
            // let getUserList
            // let getConnectionList
            // let getProviderList
            // let getDatasourceList
            // let getDatasourcemappingList
            // let getScheduleList
            // let getFrequencyList
            // let hasActiveSchedule
            // let taskScheduleStatus

            // for (let n in endpoints) {
            //     if (endpoints[n].name === "audits") {
            //         getAuditList = endpoints[n].list
            //     } else if (endpoints[n].name === "users") {
            //         getUserList = endpoints[n].list
            //     } else if (endpoints[n].name === "providers") {
            //         getProviderList = endpoints[n].list
            //     } else if (endpoints[n].name === "connections") {
            //         getConnectionList = endpoints[n].list
            //     } else if (endpoints[n].name === "datasources") {
            //         getDatasourceList = endpoints[n].list
            //     } else if (endpoints[n].name === "datasourcemappings"){
            //         getDatasourcemappingList = endpoints[n].list
            //     } else if (endpoints[n].name === "frequencies"){
            //         getFrequencyList = endpoints[n].list
            //     } else if (endpoints[n].name === "schedules"){
            //         getScheduleList = endpoints[n].list
            //     }
            // }

            if (endpointName === "tasks") {
              if (l.id) {
                hasActiveSchedule = getScheduleList.find(
                  gsl => gsl.task_id === l.id
                );
                if (hasActiveSchedule) {
                  if (hasActiveSchedule.status != null) {
                    taskScheduleStatus = hasActiveSchedule.status;
                  }
                }
              }
            }

            innerList.push(
              <div
                className={`col-1 ${endpointName}`}
                key={`${endpointName}-status`}
              >
                <span className="">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={activated}
                      onChange={e => {
                        let getDatasourceId;
                        let getConnectionId;
                        let getFrequencyId;
                        let hasIntegration;
                        let hasConnection;
                        let hasSchedule;
                        let epStatus = l.status;
                        let epName;
                        let oepName;
                        let checkDatasourceId;
                        let checkDatatargetId;
                        let checkFrequencyId;

                        if (endpointName === "connections") {
                          getConnectionId = l.id;
                          hasConnection = getDatasourceList.find(
                            gdl => gdl.connection_id === getConnectionId
                          );
                          epName = "Connection";
                          oepName = "Datasource";
                        } else if (endpointName === "datasources") {
                          getDatasourceId = l.id;
                          checkDatasourceId = getDatasourcemappingList.find(
                            gdml => gdml.datasource_id === getDatasourceId
                          );
                          checkDatatargetId = getDatasourcemappingList.find(
                            gdml => gdml.datatarget_id === getDatasourceId
                          );
                          if (
                            checkDatasourceId ||
                            checkDatatargetId ||
                            (checkDatasourceId && checkDatatargetId)
                          ) {
                            hasIntegration = true;
                          } else {
                            hasIntegration = false;
                          }
                          epName = "Datasource";
                          oepName = "Integration";
                        } else if (endpointName === "frequencies") {
                          getFrequencyId = l.id;
                          checkFrequencyId = getScheduleList.find(
                            gsl => gsl.frequency_id === getFrequencyId
                          );
                          if (checkFrequencyId) {
                            hasSchedule = true;
                          } else {
                            hasSchedule = false;
                          }
                          epName = "Frequency";
                          oepName = "Schedule";
                        }

                        if (hasConnection && epStatus != 0) {
                          this.props.dispatch(
                            showMessage({
                              type: "error",
                              title: "Error",
                              message: `Unable to deactivate ${epName} due to a related ${oepName}. `
                            })
                          );
                        } else if (hasIntegration && epStatus != 0) {
                          this.props.dispatch(
                            showMessage({
                              type: "error",
                              title: "Error",
                              message: `Unable to deactivate ${epName} due to a related ${oepName}. `
                            })
                          );
                        } else if (hasSchedule && epStatus != 0) {
                          this.props.dispatch(
                            showMessage({
                              type: "error",
                              title: "Error",
                              message: `Unable to deactivate ${epName} due to a related ${oepName}. `
                            })
                          );
                        } else {
                          this.handleToggle(e, endpoint, l);
                        }
                      }}
                    />
                    <span className="slider round"></span>
                  </label>
                </span>
              </div>
            );

            if (endpointName === "tasks") {
              let checkBothStatus = 0;
              if (l.status == 0 && taskScheduleStatus == 0) {
                checkBothStatus = 0;
              } else if (l.status == 1 && taskScheduleStatus == 1) {
                checkBothStatus = 1;
              }
              {
                
                  innerList.push(
                    <div
                      className={`col-1 ${endpointName}`}
                      key={`${endpointName}-execute`}
                    >
                      <span className="execute-btn">
                        <button
                          type="button"
                          id={`execute-btn-${l.id}`}
                          className="btn btn-execute ml-1 mr-0"
                          title="execute task"
                          data-toggle="tooltip"
                          disabled={
                            l.status == 0 || this.state.isButtonClicked
                              ? true
                              : false
                          }
                          onClick={e => {
                            this.setState(
                              state => {
                                return Object.assign({}, state, {
                                  isButtonClicked: true
                                  //currentClickedButtonId: e.target.id ? e.target.id : null
                                });
                              },
                              () => {
                                let getTaskId = l.id;
                                let getCreatedAt = l.created_at;
                                let getUpdatedAt = l.updated_at;
                                let dateNow = moment(new Date())
                                  .tz("UTC")
                                  .format("YYYY-MM-DD HH:mm:ss");
                                let data = {
                                  run_datetime: dateNow,
                                  is_processed: "F",
                                  process_status: "PENDING",
                                  status: 0,
                                  process_start_at: dateNow,
                                  task_id: getTaskId,
                                  queue_no: 1,
                                  task_name: l.name
                                };

                                if (getTaskId && data) {
                                  this.props
                                    .dispatch(
                                      executeEndpointList(
                                        "jobqueues",
                                        this.props.auth.access_token,
                                        data,
                                        "POST"
                                      )
                                    )
                                    .then(response => {
                                      if (response) {
                                        this.props.dispatch(
                                          showMessage({
                                            type: "success",
                                            title: "Success",
                                            message: (
                                              <span>
                                                <b>{data.task_name}</b> has been
                                                successfully added to job-queue.
                                              </span>
                                            ),
                                            onClick: () => {
                                              this.props.history.push(
                                                "/job-queues"
                                              );
                                            }
                                          })
                                        );
                                      }

                                      this.setState(state => {
                                        return Object.assign({}, state, {
                                          isButtonClicked: false
                                        });
                                      });
                                    });
                                }
                              }
                            );
                          }}
                        >
                          {/* <i class={"fas fa-bolt "+ (enableExecute ? " fa-spin" : "")}></i> */}
                          <i className={"fas fa-bolt"}></i>
                        </button>
                      </span>
                    </div>
                  );
              }
            }

            if (endpointName === "connections") {
              {
                /*isUserAdmin &&*/
                  innerList.push(
                    <div
                      className={`col-1 ${endpointName}`}
                      key={`${endpointName}-testing`}
                    >
                      <span className="testing-btn">
                        <button
                          type="button"
                          id={`testing-btn-${l.id}`}
                          className="btn btn-testing ml-1 mr-0"
                          title="test connection"
                          data-toggle="tooltip"
                          disabled={
                            l.status == 0 || this.state.isButtonClicked
                              ? true
                              : false
                          }
                          onClick={e => {
                            this.setState(
                              state => {
                                return Object.assign({}, state, {
                                  isTestButtonClicked: true,
                                  loader: true
                                  //currentClickedButtonId: e.target.id ? e.target.id : null
                                });
                              },
                              () => {
                                let connId = l.id;
                                let connName = l.name;
                                // console.log('sad',this.state.isLoading)
                                // console.log("connId",connId)
                                // console.log("connName",connName)

                                fetch(
                                  `${REST_API}/connections/test/${connId}?access_token=${this.props.auth.access_token}`,
                                  {
                                    method: "GET",
                                    headers: {
                                      "Content-Type": "application/json"
                                    }
                                  }
                                )
                                  .then(response => {
                                    return response.json();
                                  })
                                  .then(json => {
                                    // console.log('json',json)
                                    if (json.success) {
                                      this.props.dispatch(
                                        showMessage({
                                          type: "success",
                                          title: "Success",
                                          message: `Connection Successful.`
                                        })
                                      );
                                    } else {
                                      this.props.dispatch(
                                        showMessage({
                                          type: "error",
                                          title: "Error",
                                          message: json.error.message
                                        })
                                      );
                                    }

                                    this.setState(state => {
                                      return Object.assign({}, state, {
                                        isTestButtonClicked: false
                                      });
                                    });
                                  })
                                  .catch(error => {
                                    if (error) {
                                      this.props.dispatch(
                                        showMessage({
                                          type: "error",
                                          title: "",
                                          message: `Connection Failed.`
                                        })
                                      );
                                    }

                                    this.setState(state => {
                                      return Object.assign({}, state, {
                                        isTestButtonClicked: false
                                      });
                                    });
                                  });
                              }
                            );
                          }}
                        >
                          {/* {this.state.isTestButtonClicked ?
                                            <i className="fa fa-circle-notch integration fa-spin fa-lg"></i>
                                            :
                                            <i className="fas fa-link"></i>
                                    } */}
                          {/* <i class={"fas fa-bolt "+ (enableExecute ? " fa-spin" : "")}></i> */}
                          {/* <i class={"fas fa-link "+ (enableExecute ? " fa-spin" : "")}></i> */}
                          <i className="fas fa-link"></i>
                        </button>
                      </span>
                    </div>
                  );
              }
            }
          }

          let mainDisplayPropText = l[sb.config.displayProp.field];
          if (sb.config.displayProp.type === "reference") {
            let referenceId = Number(mainDisplayPropText) || "";
            let referenceEndpoint = endpoints.find(
              endP => endP.name === sb.config.displayProp.referenceEndpoint
            );
            let referenceObject = referenceEndpoint
              ? referenceEndpoint.list.find(ref => ref.id === referenceId)
              : null;
            let referenceText = referenceObject
              ? referenceObject[sb.config.displayProp.referenceField]
              : "";
            mainDisplayPropText = referenceText || "NO TASK";
          }
          let rowStyle = {
            width: this.state.width,
            height: this.state.height,
            overflow: "hidden"
          };

          return  (
            <li key={l.id} className="list-group-item">
              <div className="row">
                {preList}
                <div className="col-3 px-1" onClick={e => this.handleHideStyle(e)} name="taskLink"
                    style={this.state.hideStyle}>
                  <Link
                    to={`${sb.label.toLowerCase()}/${l.id}`}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {mainDisplayPropText}
                  </Link>
                </div>
                {/* messagequeue list view values */}
                {innerList}
              </div>
            </li>
          );



          //}
        })
      : [];

    // let checkStringFilter = false

    // if (endpoint.id === 3 && endpoint.filter.process_status.type === "strEnum") {

    //     checkStringFilter = true
    // }

    let filters = [];
    let mobileFilters = [];
    // console.log("filter",filter)

    const filtersObject = {
      number: NumericFilter,
      string: TextFilter,
      boolean: BooleanFilter,
      reference: ReferenceFilter,
      enum: StatusFilter,
      strEnum: TextStatusFilter,
      queueEnum: QueueFilter,
      dateTime: DateTimeFilter
    };

    //Clone current filter for mobile
    let mobileFilterObj = Object.assign({}, filter);
    if (endpointName === "messagequeues") {
      mobileFilterObj = _.pick(mobileFilterObj, "task_id", "ref_id", "status");
    } else if (endpointName === "jobqueues") {
      mobileFilterObj = _.pick(mobileFilterObj, "task_id", "process_status");
    } else if (endpointName === "schedules") {
      mobileFilterObj = _.pick(mobileFilterObj, "name", "status");
    }

    if (isBrowser) {
      if(filter.updated_at){
        delete filter.updated_at
      }
      for (var n in filter) {
        var componentProps = {
          key: n,
          id: endpoint.id,
          filterName: n,
          value1:
            typeof filter[n].value1 != "number" && filter[n].type != 'enum' && filter[n].type != 'dateTime'
              ? filter[n].value1.trim()
              : filter[n].value1,
          ref: n,
          location: this.props.location
        };
        if (filter[n].exact) {
          componentProps.exact = filter[n].exact;
        }
        if (filter[n].label) {
          componentProps.label = filter[n].label;
        }
        if (filter[n].type === "reference") {
          componentProps.referenceEndpoint = filter[n].referenceEndpoint;
        }
        filters.push(e(filtersObject[filter[n].type], componentProps));
      }
    } else if (isMobile) {
      for (let b in mobileFilterObj) {
        let componentProps = {
          key: b,
          id: endpoint.id,
          filterName: b,
          value1: mobileFilterObj[b].value1,
          ref: b,
          location: this.props.location
        };
        if (mobileFilterObj[b].exact) {
          componentProps.exact = mobileFilterObj[b].exact;
        }
        if (mobileFilterObj[b].label) {
          componentProps.label = mobileFilterObj[b].label;
        }
        if (mobileFilterObj[b].type === "reference") {
          componentProps.referenceEndpoint =
            mobileFilterObj[b].referenceEndpoint;
        }
        // if (filter[n].type === "strEnum"){

        // }
        mobileFilters.push(
          e(filtersObject[mobileFilterObj[b].type], componentProps)
        );
      }
    }

    let html = (
      <CSSTransition
        in={true}
        appear={true}
        timeout={500}
        classNames="fade"
        style={{ minWidth: "940px" }}
      >
      <div style={{ minWidth: "940px !important" }}>
        <div className="filters clearfix">
          <div className="">
            <form action="" className="form-inline">
              <div
                className="form-group"
                onChange={() => {
                this.refreshOnFilterChange();
                }}
              >
                {isBrowser ? filters : mobileFilters}
                
                {endpointName == 'messagequeues' ? 
              //   <div style={{zIndex: "20", paddingRight: "5px"}} 
              //   data-toggle="tooltip"
              //   data-placement="top"
              // >
                <DateRangePicker 
                  onChange={(e)=>this.onChangeDateFilter(e,filters)}
                  placeholderText="Date filter"
                  onClear={this.state.onClear}
                  dateProps={this.props.dateValue}
                  filters={filters}
                  />
              // </div>
              : ''}
              </div>

              <div className="d-none d-sm-block">
                <ShowItems id={endpoint.id} value1={itemsPerPage} />
              </div>
              <div id="endpoint-list-btn">
                {buttonList}
              </div>
              <div className="form-group float-right text-right info-list">
                <label htmlFor="info-list" className="sr-only"></label>
                <input
                  type="text"
                  readOnly
                  className="form-control-plaintext d-none d-xl-block"
                  id="info-list"
                  value={`Showing ${listStart + 1} - ${
                  apiPaged
                  ? listEnd > listCount
                  ? listCount
                  : listEnd
                  : listEnd > currentList.length
                  ? currentList.length
                  : listEnd
                  } of ${
                  apiPaged
                  ? listCount > 1
                  ? listCount + " items"
                  : listCount + " item"
                  : currentList.length > 1
                  ? currentList.length + " items"
                  : currentList.length + " item"
                  }`}
                />
              </div>
            </form>
          </div>
        </div>
        <div className="working-view mb-5" style={{ minWidth: "940px"}}>
          {isFetching && (
            <div className="endpoint-list-overlay" style={{ zIndex: '10' }}>
              <div className="endpoint-list-overlay-icon">
                <i className="fas fa-circle-notch fa-spin fa-10x"></i>
              </div>
            </div>
          )}
          <ul className="list-group mb-5" id="styled-list">
            <li className="list-group-item sticky">
              <div className="row">
                {sb.config.preDisplayProperties.map(dp => {
                  let displayHeader = typeof dp === "string" ? dp : dp.label;

                  return (
                    <div
                      key={`${endpointName}-${displayHeader}-header`}
                      className={`${dp.columnClass || "col"} ${dp.pxClass ||
                      "px-1"} header-${displayHeader}`}
                      style={{ fontSize: "1rem !important" }}
                    >
                      {displayHeader}
                    </div>
                  );
                })}
                <div className="float-left col-3 px-1">
                  <span>
                    {sb.config.displayProp.label}
                  </span>
                </div>
            
                {sb.config.displayProperties.map(dp => {
                  if (isBrowser) {
                    let displayHeader = typeof dp === "string" ? dp : dp.label;

                    return (
                      <div
                        key={`${endpointName}-${displayHeader}-header`}
                        className={`${dp.columnClass || "col"} ${dp.pxClass ||
                        "px-1"} header-${displayHeader}`}
                        style={{ fontSize: "1rem !important" }}
                      >
                        {displayHeader}
                      </div>
                    );
                    } else if (isMobile) {
                      if (dp.mobile == true) {
                      let displayHeader =
                      typeof dp === "string" ? dp : dp.label;

                      return (
                        <div
                        key={`${endpointName}-${displayHeader}-header`}
                        className={`${dp.columnClass ||
                        "col"} ${dp.pxClass ||
                        "px-1"} header-${displayHeader}`}
                        style={{ fontSize: "1rem !important" }}
                        >
                          {displayHeader}
                        </div>
                      );
                    }
                  }
                })}

                {endpointName !== "providers" &&
                  endpointName !== "messagequeues" &&
                  endpointName !== "jobqueues" &&
                  list &&
                  list[0] &&
                  list[0].hasOwnProperty("status") && (
                    <div className={`col-1 ${endpointName}`}>
                      <span>Active</span>
                    </div>
                  )}

                {((endpointName == "tasks" && isUserAdmin) || (endpointName == "tasks" && !isUserAdmin) || 
                  (endpointName == "connections" /*&& isUserAdmin*/)) && (
                    <div className={`col-1 ${endpointName}`}>
                      <span>Action</span>
                    </div>
                  )}
              </div>
            </li>

            <div style={{ fontSize: "0.75rem" }}>{lst}</div>
          </ul>
        </div>

        {listPages > 1 && !isFetching && (
        // <div className="pagination">
        <EndpointPagination
        //listCount={listCount}
        listCount={endpointName !== "tasks" ? listCount : currentList.length}
        id={endpoint.id}
        itemsPerPage={itemsPerPage}
        currentListPage={currentListPage}
        listPages={listPages}
        handleClick={handleClick}
        handleClickPagination={handleClickPagination}
        />
        )
        }
      </div>
      </CSSTransition>
    );

    let addNewBtn = (
      <Link to={`/${sb.label.toLowerCase()}/new`}>
        <button className="btn btn-custom add-btn">
          <i className="fas fa-plus"></i> New
        </button>
      </Link>
    );
    let showBtn =
      this.breadCrumb()[4] ||
      !isUserAdmin ||
      sb.config.readOnly ||
      sb.config.editOnly
        ? ""
        : addNewBtn;
    // let breadcrumbLink = this.breadCrumb()[3].split('-')
    // let slicedBread1 = breadcrumbLink[0] ? breadcrumbLink[0].charAt(0).toUpperCase() + breadcrumbLink[0].slice(1) : ''
    // let slicedBread2 = breadcrumbLink[1] ? '-' + breadcrumbLink[1].charAt(0).toUpperCase() + breadcrumbLink[1].slice(1) : ''

    return (
      <div className="">
        {!loader && !exportLoader ? (
          <div className="component-title list-group" id="working-area">
            <div className="list-group-item list-group-item-action gradient-background">
              <div className="" id="endpoint-label-wrapper">
                <BreadCrumb endpoint={endpoint} />
                <div className="">{showBtn}</div>
              </div>
            </div>
            {this.state.isButtonClicked && (
              <div className="integration-form-overlay">
                <div className="integration-form-overlay-icon">
                  <i className="fa fa-circle-notch integration fa-spin fa-lg"></i>
                </div>
              </div>
            )}
            {/* {loader  && endpointName === 'messagequeues' && 
                            <div className="container-archive">
                                <div className="integration-form-overlay-archive">
                                    <div className="integration-form-overlay-icon">
                                        <i className="fa fa-circle-notch integration fa-spin fa-lg"> </i>
                                        <div>
                                            <h4 style={{color: "#1E1E1E"}}>ARCHIVING PLEASE WAIT...</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        } */}
            <CSSTransition
              in={true}
              appear={true}
              timeout={500}
              classNames="fade"
            >
              {/* ENDPOINT TABLE LIST */}
              <div id="working-area-content" >
                {!err && match.isExact && html}
                {this.state.isTestButtonClicked && (
                  <div className="integration-form-overlay">
                    <div className="integration-form-overlay-icon">
                      <i className="fa fa-circle-notch integration fa-spin fa-lg"></i>
                    </div>
                  </div>
                )}
              </div>
            </CSSTransition>

            <Switch>
              <Route
                path={`/${sb.label.toLowerCase()}/new`}
                exact
                render={() =>
                  e(displayForm[sb.config.formComponent], {
                    auth: auth,
                    endpoint: endpoint,
                    location: location,
                    formType: "new",
                    parentUrl: "/" + sb.label.toLowerCase(),
                    readOnly: sb.config.readOnly,
                    updateEndpoint: false
                  })
                }
              />
              <Route
                path={`/${sb.label.toLowerCase()}/:id`}
                exact
                render={() =>
                  e(displayForm[sb.config.formComponent], {
                    auth: auth,
                    endpoint: endpoint,
                    location: location,
                    formType: "edit",
                    parentUrl: "/" + sb.label.toLowerCase(),
                    readOnly: sb.config.readOnly,
                    updateEndpoint: false
                  })
                }
              />

              {extraRoutes.map((route, i) => (
                <Route
                  exact
                  key={`endpoint-route-${route.componentName}-${i}`}
                  path={route.path}
                  render={() =>
                    e(displayForm[route.componentName], {
                      auth: auth,
                      endpoint: endpoint,
                      location: location,
                      parentUrl: "/" + sb.label.toLowerCase(),
                      updateEndpoint: false
                    })
                  }
                />
              ))}
            </Switch>
          </div>
        ) : loader && (endpointName === "messagequeues" || endpointName === 'jobqueues') ? (
          <div className="container-archive">
            <div className="integration-form-overlay-archive">
              <div className="integration-form-overlay-icon">
                <i className="fa fa-circle-notch integration fa-spin fa-lg">
                  {" "}
                </i>
                <div>
                  <h4 style={{ color: "#1E1E1E" }}>
                    {endpointName === "messagequeues" ? "Archiving, please wait..." : "Deleting, please wait..."}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        ) : (
          exportLoader &&
          endpointName === "messagequeues" && (
            <div className="container-archive">
              <div className="integration-form-overlay-archive">
                <div className="integration-form-overlay-icon">
                  <i className="fa fa-circle-notch integration fa-spin fa-lg">
                    {" "}
                  </i>
                  <div>
                    <h4 style={{ color: "#1E1E1E" }}>
                      Exporting, please wait...
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          )
        )

        // <i className="fa fa-circle-notch fa-spin fa-fw" style= {{align:'center'}}></i>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loader: state.loader.loadingMessagequeue,
    endpoints: state.endpoints,
    main: state.main,
    auth: state.auth,
    messageBox: state.messageBox,
    exportLoader: state.loader.loadingExport,
    dateValue: state.dateFilter,
    userId : state.auth.user.id
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    handleClick: (e, currentListPage, id, fieldValue) => {
      var nameArr = e.split(PAGE_BUTTON_ID);

      let nextListPage = null;

      if (nameArr[1] === "prev") {
        nextListPage = currentListPage - 1;
      } else if (nameArr[1] === "next") {
        // console.log('sad',currentListPage+1)
        nextListPage = currentListPage + 1;
      }
      // console.dir(e.currentTarget[0].value)
      else if (nameArr[1] === "input") {
        fieldValue = fieldValue - 1;

        //CHECK IF CURRENT LIST PAGE VALUE IS GREATER  OR LESSER THAN
        nextListPage = fieldValue == "-1" ? 0 : fieldValue;
        nextListPage =
          nextListPage > currentListPage ? currentListPage : nextListPage;
      } else if (nameArr[1] === "go") {
        // console.log('nameArr[1]',nameArr[1])
        fieldValue = fieldValue - 1;

        //CHECK IF CURRENT LIST PAGE VALUE IS GREATER  OR LESSER THAN
        nextListPage = fieldValue == "-1" ? 0 : fieldValue;
        nextListPage =
          nextListPage > currentListPage ? currentListPage : nextListPage;
      }

      dispatch(setCurrentListPage(id, nextListPage));
    },
    handleClickPagination: (nextListPage, id) => {
      // console.log('ZXCZXC',[nextListPage,id])
      dispatch(setCurrentListPage(id, nextListPage));
    }
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EndpointList)
);



// WEBPACK FOOTER //
// ./src/components/endpointList.js